module.exports = __webpack_public_path__ + "static/media/orbit1.25fc69e8.svg";